import type { DynamicsEnvironment } from './env'

/**
 * Each Dynamics org talks only to the proposal API pinned to it; the others
 * answer 403 for a foreign org. Prod uses the build-time URL.
 */
export const PROPOSAL_API_URLS: Record<Exclude<DynamicsEnvironment, 'prod'>, string> = {
  dev: 'https://daisy-proposal-api-dev.azurewebsites.net',
  sandbox: 'https://daisy-proposal-api-sandbox.azurewebsites.net',
}

export function proposalApiBaseUrl(environment: DynamicsEnvironment, prodBuildUrl: string): string {
  return environment === 'prod' ? prodBuildUrl : PROPOSAL_API_URLS[environment]
}
